import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../utils/hooks'
import { Styles } from '../../../../types'
import { getUserInfo } from '../../../../store/userInfo/userInfoSlice'

const styles: Styles = {
  paddingContainer: (theme) => ({
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
    [theme.breakpoints.up('mobile')]: {
      width: '50%',
    },
    marginBottom: '2.5rem',
  }),
}

const FormAutoPopName = () => {
  const userInfo = useAppSelector(getUserInfo)
  const { t } = useTranslation()

  return (
    <Box style={{ padding: '0 1.4375rem' }} sx={styles.paddingContainer}>
      <Box
        sx={(theme) => ({
          fontFamily: 'Prelo-Black, sans-serif',
          fontSize: '1rem',
          paddingBottom: '0.5rem',
          color: theme.palette.text.primary,
        })}
        data-testid="Lbl_SupportForm_NameField_Label">
        {t('Name')}
      </Box>
      <Box
        sx={(theme) => ({
          wordBreak: 'break-all',
          fontFamily: 'Prelo-Book, sans-serif',
          fontSize: '1rem',
          color: theme.palette.text.primary,
        })}
        data-testid="Lbl_SupportForm_NameField_Value">
        {userInfo.firstName &&
          userInfo.lastName &&
          `${userInfo?.firstName} ${userInfo?.lastName}`}
      </Box>
    </Box>
  )
}

export default FormAutoPopName
